
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/join-as-breeder",
      function () {
        return require("private-next-pages/join-as-breeder/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/join-as-breeder"])
      });
    }
  